// Douglas Metal Finishing - Main JavaScript
// Bootstrap JS is already included via CDN

console.log('Douglas Metal Finishing - Site Loaded');

// Syntax highlighting (PrismJS) - progressive enhancement
try {
  if (window.Prism && typeof window.Prism.highlightAll === 'function') {
    // Initial highlight
    window.Prism.highlightAll();

    // Re-highlight code inside newly shown Bootstrap tabs (important for tabbed code-blocks)
    document.addEventListener('shown.bs.tab', function(e) {
      const targetSelector = e && e.target ? e.target.getAttribute('data-bs-target') : null;
      if (!targetSelector) return;
      const pane = document.querySelector(targetSelector);
      if (!pane) return;

      // Skip line-numbered blocks (they contain injected spans that Prism doesn't expect)
      if (pane.querySelector('pre.with-line-numbers .line-number')) return;

      if (typeof window.Prism.highlightAllUnder === 'function') {
        window.Prism.highlightAllUnder(pane);
      } else {
        window.Prism.highlightAll();
      }
    });
  }
} catch (_) {
  // no-op
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// INC64: Scroll-driven binary parallax columns.
// Alternate columns move up/down based on page scroll position.
(function initInc64BinaryParallax() {
  const body = document.body;
  if (!body || !body.classList.contains('site-inc64')) return;

  const mainContent = document.getElementById('main-content');
  if (!mainContent) return;

  let layer = mainContent.querySelector('.inc64-binary-parallax');
  if (!layer) {
    layer = document.createElement('div');
    layer.className = 'inc64-binary-parallax';
    layer.setAttribute('aria-hidden', 'true');
    mainContent.prepend(layer);
  }

  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const desktopSpeeds = [0.22, -0.18, 0.14, -0.24, 0.17, -0.2];
  const mobileSpeeds = [0.18, -0.14, 0.2, -0.16];
  let cols = [];
  let rafPending = false;

  const getColumnCount = () => (window.innerWidth < 992 ? 4 : 6);

  const buildColumns = () => {
    const count = getColumnCount();
    const speeds = count === 4 ? mobileSpeeds : desktopSpeeds;
    layer.style.setProperty('--inc64-binary-cols', String(count));
    layer.innerHTML = '';
    cols = [];

    for (let i = 0; i < count; i += 1) {
      const col = document.createElement('div');
      const base = (i * 47) % 220;
      col.className = 'inc64-binary-col';
      col.dataset.speed = String(speeds[i % speeds.length]);
      col.dataset.base = String(base);
      col.style.transform = `translate3d(0, ${base}px, 0)`;
      layer.appendChild(col);
      cols.push(col);
    }
  };

  const update = () => {
    rafPending = false;
    if (prefersReducedMotion) return;

    const y = window.scrollY || window.pageYOffset || 0;
    cols.forEach((col) => {
      const speed = parseFloat(col.dataset.speed || '0');
      const base = parseFloat(col.dataset.base || '0');
      const offset = base + y * speed;
      col.style.transform = `translate3d(0, ${offset}px, 0)`;
    });
  };  const scheduleUpdate = () => {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(update);
  };

  buildColumns();
  update();

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener(
    'resize',
    () => {
      buildColumns();
      scheduleUpdate();
    },
    { passive: true }
  );
})();

// INC64: Faint starfield scroll parallax for designated white sections.
(function initInc64StarfieldParallax() {
  const body = document.body;
  if (!body || !body.classList.contains('site-inc64')) return;

  const sections = Array.from(document.querySelectorAll('.inc64-starfield-scroll'));
  if (!sections.length) return;

  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) return;

  let rafPending = false;

  const update = () => {
    rafPending = false;
    const vh = window.innerHeight || 1;

    sections.forEach((section, index) => {
      // Keep motion viewport-relative so the star layers never drift fully off-section.
      const rect = section.getBoundingClientRect();
      const centerOffset = (rect.top + rect.height * 0.5) - (vh * 0.5);
      const base = (index % 2 === 0 ? 10 : -10);
      const shift = (centerOffset * -0.14) + base;
      const shiftAlt = (centerOffset * 0.09) - base;
      section.style.setProperty('--inc64-star-shift', `${shift.toFixed(2)}px`);
      section.style.setProperty('--inc64-star-shift-alt', `${shiftAlt.toFixed(2)}px`);
    });
  };

  const scheduleUpdate = () => {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
})();